<template>
  <div id="notificationNotice"
       v-show="show"
       @click="clickBanner">
    <span class="icon"></span>
    <span class="text" :class="{ ios: ios }">开启推送通知，重要消息不错过</span>
    <span class="close"
          @click="closeNotice"></span>
  </div>
</template>

<script>
import {
  bridge, log, os, webviewInfo, util
} from '@ali/amap-lib';
import service from '../../../common/js/service';
import ConfigAct from '../../../config/config.act';
import msg from '../../../common/js/msgbox';
import '@ali/act-lib';

export default {
  name: 'NotificationNotice',
  data() {
    return {
      closeBtnClickedTime: null,
      closeBtnClickedKey: '',
      viewCount: 0,
      viewCountKey: '',
      modelShowCountKey: '',
      hasNoticePermission: null,
      gt1060: false,
      gt1206: false,
      isInCloseDuration: null,
      noticeBarClosed: false, // 用户手动关闭提示条
      ios: os.ios,
      // URL参数
      //  notice=bar 只展示提示条，并且忽略疲劳度限制
      //  notice=dialog 只展示弹窗，并且忽略疲劳度限制
      //  notice='' 按原有逻辑展示
      noticeType: util.getUrlParam('notice'),
    };
  },
  computed: {
    /**
     * 版本 >= 1060
     * 关闭通知权限
     * 自然月浏览量 >= 2
     * 如果关闭过提示条，距离上次关闭时间 > 7day
     */
    show() {
      const canShow = (
        // 前置检查
        this.gt1060 === true
        && this.hasNoticePermission === false
        && (
          // URL带bar参数，不看疲劳度，不管弹窗展示与否（强制出提示条）
          this.noticeType === 'bar'
          || (
            this.noticeType === ''
            && this.isInCloseDuration === false
            && this.modelCanShow === false
          )
        )
      );

      console.log({
        gt1060: this.gt1060,
        // viewCount: this.viewCount,
        hasNoticePermission: this.hasNoticePermission,
        isInCloseDuration: this.isInCloseDuration,
        modelCanShow: this.modelCanShow,
        noticeType: this.noticeType,
      }, canShow);

      return canShow && !this.noticeBarClosed;
    },
  },

  watch: {
  },
  beforeCreate() {
  },
  async created() {
    // this.showNoticeModal();
    if (!webviewInfo.isInAmap()) {
      return false;
    }

    /**
     * 控频：本地存储的 key
     * - 浏览次数，自然月周期
     * - 按钮关闭时间
     * - 弹窗展示时间 todo 二期需求
      */
    const d = new Date();
    this.viewCountKey = `${ConfigAct.name}-${d.getFullYear()}-${d.getMonth() + 1}—viewCount`;
    this.closeBtnClickedKey = `${ConfigAct.name}-${d.getFullYear()}-${d.getMonth() + 1}—close`;
    this.modelShowCountKey = `${ConfigAct.name}-${d.getFullYear()}-${d.getMonth() + 1}-show`;

    // 记录浏览量
    this.increaseViewCount();

    // 判断版本
    this.gt1060 = await service.compareAppVersion('100600')
      .catch(() => false);

    this.gt1206 = await service.compareAppVersion('120600')
      .catch(() => false);

    if (!this.gt1060) {
      return false;
    }

    // 如果拥有了权限/或者无法查询 直接不展示
    this.hasNoticePermission = await this.checkPermission()
      .catch(() => null);

    if (this.hasNoticePermission === false) {
      log.log('pageview2022fwcn');
    }

    this.isInCloseDuration = this.checkCloseBtnEffectDuration();

    const hasNotShow = this.checkModelHasNotShow();
    this.modelCanShow = (
      // 前置检查
      this.gt1206 === true
      && this.hasNoticePermission === false
      && (
        // URL带dialog参数，不看疲劳度
        (this.noticeType === 'dialog')
        // 原逻辑
        || (this.noticeType === '' && hasNotShow === true)
      )
    );

    if (this.modelCanShow) {
      this.showNoticeModal();
    }

    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible') {
        this.hasNoticePermission = await this.checkPermission()
          .catch(() => null);
      }
    });
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    /**
     * 每次浏览增加一次，浏览统计
     * key 为 activityId-year-month
     */
    increaseViewCount() {
      let count = 0;
      try {
        let c = parseInt(JSON.parse(localStorage.getItem(this.viewCountKey)), 10);
        if (Number.isNaN(c)) {
          c = 0;
        }
        count = c;
      } catch (e) {
        count = 0;
      }
      count += 1;

      try {
        localStorage.setItem(this.viewCountKey, count);
      } catch (e) {
        // do nothing
      }

      // 本月的浏览量
      this.viewCount = count;
    },

    /**
     * 检查是否有通知权限（静默查询，无引导窗）
     * @returns {Promise<unknown>}
     */
    checkPermission() {
      return new Promise((resolve, reject) => {
        bridge.send({
          action: 'getAuthorizationInfo',
          permissionType: 'notification',
        }, (result) => {
          // alert(JSON.stringify(result));

          // 无返回
          if (!result) {
            reject(new Error('no result'));
            return false;
          }

          const { code, message = '', isEnabled } = result;

          // code 出现错误
          if (code !== 1) {
            reject(new Error(message));
            return false;
          }

          const { noLongerPrompt } = result;
          if (noLongerPrompt === true) {
            reject(new Error('noLongerPrompt is true'));
            return false;
          }

          resolve(isEnabled);
        });
      });
    },

    async clickBanner() {
      this.hasNoticePermission = await this.requestPermission()
        .catch(() => null);
    },
    /**
     * 请求通知权限（会弹出引导窗）
     * @returns {Promise<unknown>}
     */
    requestPermission() {
      log.log('click2022tishitiao');

      return new Promise((resolve, reject) => {
        if (this.gt1206) {
          const res = window.ajx.permission.getAuthorizationInfo('notification') || {};
          // alert(JSON.stringify(res));
          if (!res) {
            reject(new Error('no rerult'));
            return false;
          }
          const { isEnabled } = res;

          if (!isEnabled) {
            window.ajx.permission.openAppSettingsPage();
          }
        } else {
          bridge.send({
            action: 'requestAuthorizationWithDialog',
            permissionType: 'notification',
          }, (result) => {
            // alert(JSON.stringify(result));
            // 无返回
            if (!result) {
              reject(new Error('no result'));
              return false;
            }

            const {
              code, message = '', isAuthorized, noLongerPrompt
            } = result;

            if (noLongerPrompt === true) {
              reject(new Error('noLongerPrompt is true'));
              return false;
            }

            // code 出现错误
            if (code !== 1) {
              reject(new Error(message));
              return false;
            }
            // alert(JSON.stringify(result));
            resolve(isAuthorized);
          });
        }
      });
    },

    /**
     * 检查是否在上次关闭按钮有效期内
     */
    checkCloseBtnEffectDuration() {
      let t = null;
      // 读取本地时间
      try {
        t = JSON.parse(localStorage.getItem(this.closeBtnClickedKey));

        if (Number.isNaN(t)) {
          t = null;
        }
      } catch (e) {
        t = null;
      }

      if (t === null) {
        return false;
      }

      this.closeBtnClickedTime = t;
      return ((Date.now() - this.closeBtnClickedTime) / 1000 / 60 / 60 / 24) <= 7;
    },

    /**
     * 关闭当前打开系统通知权限的提示
     */
    closeNotice(event) {
      log.log('close2022tishitiao');

      event.stopPropagation();
      // 将当前点击时间记录在本地
      try {
        const value = Date.now();
        this.closeBtnClickedTime = value;
        localStorage.setItem(this.closeBtnClickedKey, JSON.stringify(value));
        // eslint-disable-next-line no-shadow
      } catch (e) {
        // do nothing
      }
      this.noticeBarClosed = true;
    },

    checkModelHasNotShow() {
      let c = false;
      try {
        c = JSON.parse(localStorage.getItem(this.modelShowCountKey));
      } catch (e) {
        c = false;
      }

      return c !== true;
    },

    showNoticeModal() {
      try {
        localStorage.setItem(this.modelShowCountKey, JSON.stringify(true));
      } catch (e) {
        // do nothing
      }
      // h5 弹窗埋点
      log.log('pageview2022tanchuangcuina');

      msg({
        content: '开启系统通知',
        tips: '如您对当前页面感兴趣，推荐开启推送通知，避免错过重要消息',
        closeFun() {
        },
        btns: [
          {
            text: '关闭',
            fun: () => {
              log.log('close2022tanchuang');
            }
          },
          {
            text: '去开启',
            fun: () => {
              log.log('click2022tanchuang');
              this.requestPermission();
            }
          }
        ]
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/css/common-mixin";
#notificationNotice {
  color: #996C43;
  padding: rpx(24px) rpx(29px) rpx(24px) rpx(26px);
  margin: rpx(-40px) rpx(16px) rpx(16px);
  background-color: #FCEFDC;
  height: rpx(88px);
  border-radius: rpx(16px);
  overflow: hidden;
  display: flex;
  align-items: center;
  align-content: flex-end;
  box-sizing: border-box;
  //justify-content: space-between;

  .icon {
    position: relative;
    display: block;
    margin-right: rpx(10px);
    width: rpx(32px);
    height: rpx(32px);
    background: url("../../../assets/notification/icon-volume-m.png") center no-repeat;
    background-size: 100% 100%;
  }

  .text {
    font-size: rpx(28px);
    height: rpx(30px);
    line-height: rpx(30px);
    padding: rpx(5px) 0;
    display: flex;
    //vertical-align: middle;
    align-items: center;
    font-family: miui, "PingFang SC", Arial, sans-serif;
    //background: red;
    transform: translateY(rpx(3px));

    &.ios {
      transform: translateY(0);
    }
  }

  .close {
    right: rpx(29px);
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
    position: absolute;
    display: block;
    float: right;
    width: rpx(32px);
    height: rpx(32px);
    background: url("../../../assets/notification/ic-close-o.png") center no-repeat;
    background-size: 100% 100%;
  }
}
</style>

<style lang="scss">
@import "../../../common/css/common-mixin";
.msgbox-container .msgbox-body .msgbox-footer .msgbox-btn[data-index="0"] {
  color: #333;
}

.msgbox-container .msgbox-body .msgbox-content {
  font-size: rpx(32px);
  font-weight: bold;
}

.msgbox-container .msgbox-body .msgbox-content .msgbox-tips {
  font-size: rpx(28px);
  font-weight: normal;
}

.msgbox-container .msgbox-body .msgbox-footer .msgbox-btn {
  font-size: rpx(32px);
  line-height: rpx(94px);
  padding: 0;
  height: rpx(94px);
}
</style>
